import React, { useContext, useState } from 'react';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
import { useFetch } from 'use-http';
import Dialog from './Dialog.redesign';
import { Form, TextInput } from 'src/components/controls/forms/reactHookForm';
import * as yup from 'yup';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';

interface IGlobalSearchDialog {
    onCloseDialog?: () => void;
}

const GlobalSearchDialog: React.FC<IGlobalSearchDialog> = (props) => {
    const appContext = useContext<IAppContextState>(AppContext);
    const [errorMessage, setErrorMessage] = useState<string>(undefined);
    const { get, response } = useFetch();
    const dispatch = useDispatch();

    type SearchModel = {
        searchTerm: string;
    };

    const schema = yup.object().shape({
        searchTerm: yup
            .string()
            .required('Search Term is required')
            .test('search-term', 'Improper format', (term: string) => {
                const items = term.split('.');
                if (items.length > 4) {
                    return false;
                }
                return items.map(Number).reduce((a: boolean, b: number) => a && !isNaN(b), true);
            }),
    });

    const buildInitialSearchTerm = () => {
        let searchTerm = '';

        if (appContext.clientNumber) {
            searchTerm = appContext.clientNumber + '.';
        }

        if (appContext.projectNumber) {
            searchTerm += appContext.projectNumber + '.';
        }

        if (appContext.fieldNumber) {
            searchTerm += appContext.fieldNumber + '.';
        }

        return searchTerm;
    };

    const initValues: SearchModel = {
        searchTerm: buildInitialSearchTerm(),
    };

    const submitForm = async (values: SearchModel) => {
        setErrorMessage(undefined);
        const result = await get(`/v1.0/search/${values.searchTerm}`);

        if (response.ok) {
            dispatch(push('/'));
            dispatch(push(result.path));
            props.onCloseDialog();
        } else {
            setErrorMessage('Could not find result');
        }
    };

    return (
        <Dialog title="Global Search">
            <div style={{ textAlign: 'center', background: 'white', padding: '1rem', borderBottom: '1px solid #ccc', marginBottom: '1rem' }}>
                <div>Enter search term below in the following format:</div>
                <div style={{ fontWeight: 'bold' }}>[Client #].[Project #].[Section/Map #].[Tract #]</div>
            </div>
            <Form
                onSubmit={submitForm}
                validationSchema={schema}
                showHeader={false}
                defaultValues={initValues}
                showSubmitButton={true}
                submitButtonText="Search"
            >
                <TextInput autoFocus={true} style={{ width: '100%' }} name="searchTerm" label="Enter DLC ID" />
            </Form>
            {errorMessage && <div>{errorMessage}</div>}
        </Dialog>
    );
};

export default GlobalSearchDialog;



// WEBPACK FOOTER //
// ./src/components/common/GlobalSearchDialog.tsx